import { brandSecondary, mention } from '../../../../styles/colors';
import { SvgIcon } from '../../icons/SvgIcon';

export const BrandSettingsIcon = ({ height = 60, width = 60 }: { height: number; width: number }) => {
	return (
		<SvgIcon height={height} width={width}>
			<g fill='none' fillRule='evenodd'>
				<circle cx='30' cy='30' r='30' fill={mention} />
				<g transform='translate(15 15)'>
					<rect x='0' y='0' width='12' height='12' rx='2' fill={brandSecondary} />
					<rect x='14' y='0' width='12' height='12' rx='2' fill='#4A90D9' />
					<rect x='7' y='14' width='12' height='12' rx='2' fill='#7B68EE' />
				</g>
			</g>
		</SvgIcon>
	);
};
